"use strict";
import { AlertBannerMarkup } from "./";
export const Template = AlertBannerMarkup;
//# sourceMappingURL=template.js.map
